import React from 'react';
import { mdiFolderOutline, mdiFolder, mdiClose } from '@mdi/js';
import { Stack, ListItem, ListItemIcon, ListItemText, Typography, IconButton } from '@mui/material';
import { vars, labelFontSemiBold } from '../../../../../Theme';
import { getParentDirectory, getDirectoryName } from '../../../../../util/StringUtils';
import Icon from '@mdi/react';

export default ({
    id,
    path,
    onRemove,
}: {
    id: string;
    path: string;
    onRemove: (removeId: string) => void;
}) => {
    const hasParent = Boolean(getParentDirectory(path));

    return (
        <Stack
            direction='row'
            sx={{ width: '100%', borderBottom: `1px solid ${vars.lightGray}` }}
            key={id}
        >
            <ListItem sx={{ p: 0 }}>
                <ListItemIcon>
                    <Icon
                        path={hasParent ? mdiFolderOutline : mdiFolder}
                        color={vars.tagChipBlue}
                        size={1}
                        style={{ margin: 'auto' }}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={
                        hasParent ? (
                            <Typography
                                variant='body2'
                                sx={{
                                    fontSize: 12,
                                }}
                            >
                                {getParentDirectory(path) ?? document.title}
                            </Typography>
                        ) : undefined
                    }
                    secondary={
                        <Typography
                            sx={{
                                ...labelFontSemiBold,
                                fontSize: '16px',
                                color: vars.font,
                                fontWeight: 500,
                            }}
                        >
                            {getDirectoryName(path)}
                        </Typography>
                    }
                />
            </ListItem>
            <IconButton
                onClick={() => onRemove(id)}
                sx={{ width: '34px', height: '34px', margin: 'auto', p: 0, marginRight: '8px' }}
            >
                <Icon path={mdiClose} size={1} />
            </IconButton>
        </Stack>
    );
};
